import React, { useEffect, useState, useRef } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { connect } from 'react-redux';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import { withTranslation } from 'react-i18next';
import PhysicalConfirmationService from '../../../../services/PhysicalConfirmationService';
import { Button, Input } from '../../../../components/UI/ComponentsUI';
import ConfirmModalUI from '../../../../components/UI/ConfirmModalUI';
import { translate, updateTextFields, stringFormat, getNumberValueOrDefault } from '../../../../utils/util';
import useStateWithPromise from '../../../../utils/useEffectUpdate';

const ModalReceiptQuantity = (props) => {
    const modal = useRef();
    let instaceMT = null;
    const [instanceM, setinstanceM] = useState();
    const [model, setModel] = useStateWithPromise({});
    const [messageConfirmationBoxesQuantity, setMessageConfirmationBoxesQuantity] = useState('')
    const [openModalConfirmation, setOpenModalConfirmation] = useState(false)
    const [openModalMasterCim, setOpenModalMasterCim] = useState(false);

    useEffect(() => {
        if (props.receipt) {
            let dataObj = {};
            Object.assign(dataObj, props.receipt);
            dataObj.qtStorage = calcBalance(props.receipt);
            dataObj.qme = dataObj.qtStorage === 1 ? dataObj.balance : dataObj.qme
            dataObj.pallets = 1;
            setModel({ ...dataObj }).then(() =>
                updateTextFields()
            );
        }
        // eslint-disable-next-line
    }, [props.receipt, openModalMasterCim]);

    const loadInstance = (instance) => {
        setinstanceM(instance);
        instaceMT = instance;
    }

    useEffect(() => {
        if (openModalMasterCim) {
            var instance = M.Modal.init(modal.current, {
                dismissible: false
            });

            loadInstance(instance);
            instance.open();

            return () => {
                if (instaceMT && instaceMT.el) {
                    M.Modal.init(instaceMT.el).destroy()
                    M.Modal.init(instaceMT.el).close()
                    instaceMT.el.M_Modal.destroy()
                    instaceMT.close()
                }
            }
        }
        // eslint-disable-next-line
    }, [modal, openModalMasterCim]);


    const onChangeBoxQuantity = (event) => {
        if (getNumberValueOrDefault(event.target.value) > 0) {
            var piecePerBox = parseInt(getNumberValueOrDefault(model.balance) / getNumberValueOrDefault(event.target.value))
            model.qme = piecePerBox
        }

        onValueChange(event, model, setModel);
    };

    const validateInsert = () => {
        if (validateInputsRequired("formInput")) {
            if (model.balance < (model.qtStorage * model.qme * model.pallets)) {
                const modal = M.Modal.init(document.getElementById('deemconfirmed'));
                modal.open();
            } else {
                if (model.qtStorage > 1 && Number(model.qme) === 1) {
                    setOpenModalConfirmation(true)
                    setMessageConfirmationBoxesQuantity(stringFormat(translate('receiptMultipleBoxes1PrintConfirmation', 'physical-confirmation'), model.qtStorage))
                }
                else if (model.qtStorage >= 50) {
                    setOpenModalConfirmation(true)
                    setMessageConfirmationBoxesQuantity(stringFormat(translate('generating50OrMorePrintsConfirmation', 'physical-confirmation'), model.qtStorage))
                }
                else {
                    onConfirm()
                }
            }
        }
    }

    const validadeRemainingBalance = () => {
        var balance = getNumberValueOrDefault(model.balance)
        var qtdStorage = getNumberValueOrDefault(model.qtStorage)
        var qme = getNumberValueOrDefault(model.qme)
        var pallets = getNumberValueOrDefault(model.pallets)

        var remainingQuantity = balance - (qtdStorage * qme * pallets);
        return remainingQuantity;
    }

    const onConfirm = () => {
        if (model.remainingBalance) {
            if (props.truckKanban) {
                addListReceiptGroup(model);
                return close();
            } else {
                var remainingQuantity = props.receipt.balance - (model.qtStorage * model.qme * model.pallets);
                if (remainingQuantity > 0) {
                    let newModel = {};
                    Object.assign(newModel, props.receipt);
                    // Marca o primeiro como falso;
                    model.remainingBalance = false;
                    //Cria um novo informando que é restante do material para o mesmo pallet
                    newModel.remainingBalance = true;
                    newModel.qtStorage = 1;
                    newModel.pallets = 1;
                    newModel.qme = remainingQuantity;
                    addListReceiptGroup(newModel);
                }
            }
        }
        addListReceiptGroup(model);
        close();
    }

    const calcBalance = (value) => {
        if (value.balance) {
            var calc = parseInt(value.balance / (value.qme > 0 ? value.qme : 1) || 1);
            return calc > 0 ? calc : 1
        }

        return "";
    }

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const onCancel = (event) => {
        close();
    };

    const close = () => {
        setModel({});
        setOpenModalMasterCim(false)

        if (instanceM) {
            instanceM.close();
        }
    };

    const isMasterCim = () => {
        if (props.receiptsGroup && props.receiptsGroup.length > 0) {
            return props.receiptsGroup.find((f) => f.id === model.id);
        }
    }

    const onSetMasterCim = () => {
        if (props.receiptsGroup.find(f => f.id === model.id)) {
            props.removedReceiptGroup(model);
        } else {
            setOpenModalMasterCim(true);
        }
    }

    const addListReceiptGroup = (element) => {
        for (let index = 0; index < element.pallets; index += 1) {
            props.addReceiptGroup(element);
            props.updateMassiveItem(element.id, false);
            props.updateVisualIndicator(element.id, false);
        }
        close();
        if (props.callback) {
            props.callback()
        }
    }

    return (
        <>
            {
                !openModalMasterCim ?
                    <i
                        onClick={() => onSetMasterCim()}
                        className={`mdi mdi-48px mdi-layers-triple-outline ${!isMasterCim() ? 'gray' : 'green'}-text`}
                    /> :
                    <>
                        <ConfirmModal
                            id="deemconfirmed"
                            data={{ title: translate('general:warning'), message: translate("physical-confirmation:amountStatedGreaterThanAvailableValidation") }}
                            onConfirm={onConfirm}
                            btnCancel={translate('general:cancel')}
                            btnConfirm={translate('general:confirm')}
                        />
                        <ConfirmModalUI
                            open={openModalConfirmation}
                            id="messageAlert"
                            data={{
                                title: `${translate('validations:attention')} ${translate('confirm', 'general')}`,
                                message:
                                    <span className="title col s12" style={{ color: 'red' }}>
                                        {messageConfirmationBoxesQuantity}
                                    </span>
                            }}
                            onConfirm={() => {
                                setOpenModalConfirmation(false);
                                onConfirm()
                            }}
                            onCancel={() => setOpenModalConfirmation(false)}
                            onClose={() => setOpenModalConfirmation(false)}
                            showCancel={true}
                            btnCancel={translate('cancel', 'general')}
                            btnConfirm={translate('confirm', 'general')} />

                        <div id={props.id || 'ModalReceiptQuantity'} ref={modal} className="modal" style={{ backgroundColor: '#ffffff' }}>
                            <div className="modal-content black-text">
                                <div className="row center">
                                    <div className="sixth-text-color center">
                                        <span className="col s12">Gerar Master CIM</span>
                                    </div>
                                </div>
                                <div>
                                    <span className="field sixth-text-color f-1p5r" style={{ marginBottom: 0 }}>{translate('physical-confirmation:almox')}: {model.almox}</span>
                                </div>
                                <div id="formInput">
                                    <div className="input-field no-padding col s12" style={{ marginTop: '20px' }}>
                                        {/* Numero de Etiquetas que será geradas*/}
                                        <Input
                                            required
                                            id="qtStorage"
                                            name="qtStorage"
                                            label={translate('physical-confirmation:qt-volume')}
                                            onChange={onChangeBoxQuantity}
                                            value={model?.qtStorage}
                                            type="number"
                                            step="1"
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12" style={{ marginTop: '20px' }}>
                                        {/* Numero de items por etiqueta*/}
                                        <Input
                                            required
                                            id="qme"
                                            name="qme"
                                            label={translate('physical-confirmation:partnumber')}
                                            value={model?.qme}
                                            onChange={onChange}
                                            type="number"
                                        />
                                    </div>
                                    <div className="col s12" style={{ padding: '0px', color: 'red', paddingTop: '5px', paddingBottom: '5px' }}>
                                        <label className="field f-1p5r truncate col s12" style={{ color: 'red' }} htmlFor="remainingQuantity">{translate('physical-confirmation:remainingQuantity')}: {validadeRemainingBalance()}</label>
                                    </div>
                                    {
                                        validadeRemainingBalance() > 0 &&
                                        <div className="input-field no-padding col s12">
                                            <Input
                                                id="remainingBalance"
                                                name="remainingBalance"
                                                type="checkbox"
                                                label={translate('physical-confirmation:remainingBalance')}
                                                onChange={onChange}
                                                defaultChecked={model?.remainingBalance}
                                            />
                                        </div>
                                    }
                                    {
                                        getNumberValueOrDefault(model?.qtStorage) === 1 &&
                                        <div className="col s12" style={{ padding: '0px', color: 'red' }}>
                                            {translate("physical-confirmation:no-cim-pallet-master")}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="modal-footer" style={{ backgroundColor: '#ffffff' }}>
                                <div style={{ paddingBottom: '5px' }} >
                                    <Button
                                        className="col s6 m3 push-m6 btn btn-flat waves-effect waves-light"
                                        type="button"
                                        onClick={onCancel}
                                        disabled={props?.disabledCancel}
                                        secundary="true"
                                        text={props.btnCancel ? props.btnCancel : translate('general:cancel')} />
                                    <Button
                                        type="button"
                                        onClick={validateInsert}
                                        text={props.btnConfirm ? props.btnConfirm : translate('general:confirm')} />
                                </div>
                            </div>
                        </div>

                    </>
            }

        </>
    );
};

const mapStateToProps = (state) => {
    return {
        confirmation: state.physicalConfirmationReducer.confirmation,
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.configReducer.sheds,
        areas: state.areaReducer.areas,
        resources: state.logisticsResourceReducer.list,
        printSelect: state.physicalConfirmationReducer.printSelect,
        filter: state.physicalConfirmationReducer.filter,
        receiptsGroup: state.physicalConfirmationReducer.receiptsGroup
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateDate: (partnumber, value, key) => {
            dispatch(PhysicalConfirmationService.updateDate(partnumber, value, key));
        },
        setActiveTab: (tabIndex) => {
            dispatch(PhysicalConfirmationService.setActiveTab(tabIndex));
        },
        setPrintSelect: (printSelect) => {
            dispatch(PhysicalConfirmationService.setPrintSelect(printSelect));
        },
        removedReceiptGroup: (receipt) => {
            dispatch(PhysicalConfirmationService.removedReceiptGroup(receipt));
        },
        updateMassiveItem: (id, value) => {
            dispatch(PhysicalConfirmationService.updateMassiveIndicator(id, value));
        },
        updateVisualIndicator: (id, value) => {
            dispatch(PhysicalConfirmationService.updateVisualIndicator(id, value));
        },
        addReceiptGroup: (receipt) => {
            dispatch(PhysicalConfirmationService.addReceiptGroup(receipt));
        },
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalReceiptQuantity));
